import { createSelector } from 'reselect';
import { getFormValues } from "redux-form";
import { GENERATE_VERSIONS } from 'widgets/forms/list';

function getCreativeVersionItems(state){
	return state.creativeVersions?.items || [];
}

function getSelectedVersions(state){
	return state.selected?.versions || [];
}

function getAdType(state){
	return state.creativeDetails?.adType || "";
}

function getLibraryId(state) {
	return state.libraryProperties?.id;
}

function mapVersions(versions, selectedVersions, adType, libraryId){
	return versions.map((version) => {
		const {
			id,
			creative,
		} = version;

		const creativeId = creative?.id;

		return {
			...version,
			libraryId,
			id,
			creativeId,
			adType,
			isSelected:selectedVersions.includes(version.id),
		};
	});
}

const getGenerateVersionsValues = getFormValues(GENERATE_VERSIONS);

function countUniqueValues(items){
	let valuesSet = items.reduce((prev, item) => {
		if(!item){
			return prev;
		}
		if(typeof(item) === "object"){
			// Object values are normalized to have an `id`, which is unique per type
			// Except in the case of newly created text assets, which have a unique `data` attribute
			const id = item.id || item.data;
			if(id){
				// If the object is malformed for some reason, don't count it.
				prev.add(id);
			}
		} else {
			// If it's not an object, it should just be a string
			prev.add(item);
		}
		return prev;
	}, new Set());

	return valuesSet.size;
}

function computeVersionCount(generateVersionsFormValues){
	const { variables = {} } = generateVersionsFormValues || {};

	const values = Object.values(variables);
	if(!values.length){
		return 0;
	}

	// Multiply the number of values per variable
	return values.reduce((total, variableValues) => {
		// Valid values are objects or strings.  Don't count falsy values
		let count = countUniqueValues(variableValues);
		return total * count;
	}, 1);
}

export const mappedSelectedVersions = createSelector([getCreativeVersionItems, getSelectedVersions, getAdType, getLibraryId], mapVersions);
export const generatedVersionCount = createSelector([getGenerateVersionsValues], computeVersionCount);
